import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useNavigationBar } from "../../../context/NavigationContext";

export default function ChannelSuccess() {
  const containerStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  };
  const navigate = useNavigate();
  const { setNavProps } = useNavigationBar();

  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Channel",
      subtitle: "Submitted",
      buttonTitle: "Exit",
      filterOption: true,
      enableLink: true,
      //onBack: () => alert("Back Clicked"),
      onFilter: () => {},
      onNext: () => navigate("../onboarding"),
    });
  }, [setNavProps]);

  /*   const addChannel = async () => {
    //preventDefault();
    try {
      await db.collection("channel").add({
        userID: auth.currentUser?.uid,
        name: channelData.name,
        description: channelData.description,
        profileImageUrl: channelData.profileImageUrl,
        backgroundImageUrl: channelData.backgroundImageUrl,
        language: channelData.language,
        secondLanguage: channelData.secondLanguage,
        country: channelData.country,
        extrenalLink: channelData.extrenalLink,
        topic: channelData.topic,
        age: channelData.age,
        certifyFirst: channelData.certifyFirst,
        certifySecond: channelData.certifySecond,
        tier: channelData.tier,
        autoPublish: channelData.autoPublish,
      });
      alert("Channel successfully Stored!");
    } catch (error) {
      console.error("Error writing Channel: ", error);
    }
  }; */

  /*  useEffect(() => {
    addChannel();
  }, []); */
  //setNavProps((prev) => ({ ...prev, enableLink: true }));

  return (
    <div className="p-8 bg-white">
      <div className="flex flex-col">
        <div className="mb-5 flex flex-col space-y-[10px]">
          <div className="pt-8" style={containerStyle}>
            <img src="/images/success.png" className="items-center w-25"></img>
            <label className="block pt-5 text-lg font-semibold text-gray-400 dark:text-white">
              Your channel application successfully submitted for review. You can view the progress on your dashboard.
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
